const cards = [
    {
        title: 'Projects',
        cards: [
            {
                id: 'The Lost Wanderer',
                image: 'https://i.imgur.com/ijhzMkZ.png',
                title: 'The Lost Wanderer',
                description: 'The Lost Wanderer is an immersive three-dimensional puzzle adventure game',
            }]
    },
    {
        title: 'Works',
        cards: [
            {
                id: 'Leap of Faith',
                image: 'https://imgur.com/3Pa8aLM.png',
                title: 'Leap of Faith Suit',
                description: 'Insomniac Marvels Spider-Man: Miles Morales Custom Suit Addon Mod',
            }]
    },
];

export default cards;